export default __webpack_public_path__ + "static/MerriweatherSans-Bold-ad8b7aefcdf6b1e397c41234db9130e6.ttf";